// @ts-nocheck
import React, { useState, useEffect } from 'react';
import SearchIconSvg from "../../../assets/teacher/images/worksheets/search-icon.svg";
import CrossIconSvg from "../../../assets/teacher/images/worksheets/cross-icon.svg"
import Highlighter from "react-highlight-words";
import { DebounceInput } from 'react-debounce-input';
import { SearchDropdownFallback } from 'apps/teacher/fallbackComponents/worksheet/searchDropdownFallback';
// import { sendErrorToSentry } from 'apps/teacher/components/teacher_app_container/ErrorBoundary/sendErrorToSentry';
import * as PrintableWorksheetsApi from '../../api'
import { PRINTABLE_WORKSHEET_SCREENS, SubjectCodes, usePrintableWorksheetsState } from 'printableWorksheets/state';
import OutsideClickHandler from '../OutsideClickHandler';
import PrintableWorksheetsEvents from 'printableWorksheets/events';
import { WorksheetsEnvironment } from 'printableWorksheets';
import { useAppMediaProvider } from '../../../baseStyles/AppMediaProvider';
import SearchIcon from './searchi-icon2.svg'
import ReactDOM from 'react-dom';
import InvisibleInput from '../../../teacherDashboard/atoms/InvisibleInput';
import PDFViewer from "../../../teacherDashboard/teacher/components/common/PDFViewer";
import './styles.scss'
import '../../../assets/teacher/stylesheets/teachers/pdf_viewer.scss';
import { canDownloadWs } from 'apps/teacher/config/common';
import WSPreview from './wsPreview';


export const searchTypes = {
  TRENDING: 'Trending searches',
  RECENT: 'Recent searches',
  BEST_MATCHES: 'Best matches',
}

/**
 * This component renders the Search input and search dropdown on Worksheet page
 *
 * @property {Boolean} defaultSearch To show or hide extended search input
 * @property {String} subjectCode current subject selected
 * @property {Function} toggleDefaultSearch function to show or hide extended search input
 * @property {String} worksheetSearchValue stores values which is entered into search input
 * @property {String} gradeCode current grade code
 * @property {String} userId contains teacher id
 *
 */

interface IWSSearchProps {
    defaultSearch: boolean
    subjectCode: string;
    toggleDefaultSearch: (val: boolean) => void;
    worksheetSearchValue: string;
    gradeCode: string;
    userId: string;
    searchPlaceholder: string;
}

export const WSSearch: React.FC<IWSSearchProps> = ({
  defaultSearch = false,
  subjectCode = "math",
  toggleDefaultSearch = () => { },
  worksheetSearchValue = '',
  gradeCode = "",
  userId = null,
  searchPlaceholder = null
}) => {

  // const dispatch = useDispatch();

  const [worksheetName, setWorksheetName] = useState(worksheetSearchValue)
  const [searchResults, setSearchResults] = useState([])
  const [searchType, setSearchType] = useState(searchTypes.RECENT)
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [trendingWorksheet, setTrendingWorksheet] = useState([])
  const [initialLoading, setInitialLoading] = useState(true);
  const { worksheetsEnvironment, activeGrade, onboardingGrade, downloadedWorksheets, activeBreadcrumb, setFilteredSearchTerm, setActiveScreen, setSearchScreenData, setDownloadedWorksheets, setDownloadCount } = usePrintableWorksheetsState();
  const { currentDevice, isDesktop } = useAppMediaProvider();
  const [switchToIcon, toggleSwitchToIcon] = useState<boolean>(false);
  const {isMobile} = useAppMediaProvider();
  const [showWorksheetPreview, setShowWorksheetPreview] = useState(false);
  const [showUnlockButton, setShowUnlockButton] = useState(false);
  const [worksheetDetail, setWorksheetDetail] = useState(null);

  useEffect(() => {
    if(isMobile){
      toggleSwitchToIcon(true);
    } else {
      toggleSwitchToIcon(false);
    }
  }, [currentDevice]);

  useEffect(() => {
    if(userId){
      if(worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD){
        getTrendingWorksheets();
      } else {
        checkForFirstTimeClick([]);
      }
    }
  }, [userId])

  useEffect(() => {
    let wsRailsContainerDiv = document.getElementsByClassName('ws-rails-container')?.[0];
    if(wsRailsContainerDiv){
      if(!defaultSearch && !initialLoading && searchResults?.length > 0){
        wsRailsContainerDiv.style.pointerEvents = 'none'
     } else {
       wsRailsContainerDiv.style.pointerEvents = 'all';
     }
    }
  }, [defaultSearch, initialLoading, searchResults])

  const checkForFirstTimeClick = (trendingWsList = []) => {
    let alreadyFirstTime = localStorage.getItem("First_Time_Click_On_Search" + userId + subjectCode + gradeCode)
    if(worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD){
      if (!alreadyFirstTime) {
        localStorage.setItem("First_Time_Click_On_Search" + userId + subjectCode + gradeCode, true)
        setSearchType(searchTypes.TRENDING)
        setSearchResults(trendingWsList)
        setInitialLoading(false)
      }
      else {
        getRecentUserSearches(trendingWsList)
      }
    }
  }

  const onDownload = (worksheetDetails) => {
    if (worksheetDetails.id && userId) {
      // GlobalSpinner.show();
      fetch(worksheetDetails.pdf_url, {
          credentials: 'omit'
      }).then((res) => res.blob()).then((blob) => {
          // GlobalSpinner.hide();
          const a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = worksheetDetails.title;
          a.target = '_system';
          a.click();
          a.remove();
          if(worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD){
            PrintableWorksheetsApi.postSaveUserDownload({
              userId,
                params: {
                    entity_id: worksheetDetails.id,
                    entity_type: 'SearchContent'
                },
                callback: () => {
                  showFlashMessage('Worksheet downloaded successfully', 'success');
                  if(!downloadedWorksheets.find((ws: any) => ws.id === worksheetDetails.id)){
                    setDownloadedWorksheets((dws: any) => [...dws, worksheetDetails]);
                    setDownloadCount((downloadCount: number) => downloadCount + 1);
                }
                  if(worksheetsEnvironment == WorksheetsEnvironment.TEACHER_DASHBOARD){
                    window?.dispatchEvent(new CustomEvent('download-worksheets-update'));
                    const props = {
                      worksheetName: worksheetDetails.title,
                      worksheetGrade: gradeCode.toLowerCase(),
                      worksheetCategory: "",
                      worksheetSubcategory: "",
                      from: selectedPdf ? "Preview" : "Worksheet Listing Page"
                    }
                    PrintableWorksheetsEvents.downloadedWorksheet(props);
                  }
                }
            })
          }
      }).catch((e)=> {
        // sendErrorToSentry(new Error("Worksheet download failed"), worksheetDetails)
      })
    }
  };

  const onSearchInputChange = (e) => {
    setWorksheetName(e.target.value)
    if (e.target.value !== "") {
      // getSearchResults api returns empty in case of single character
      if(e.target.value.length > 1) {
        getSearchResults(e.target.value)
      }
    }
    else {
      setSearchType(searchTypes.TRENDING)
      setSearchResults(trendingWorksheet)
    }
  }

  const getSearchResults = (query = '') => {
    setSearchType(searchTypes.BEST_MATCHES);
    PrintableWorksheetsApi.getSearchResults({
        params: {
          query,
          grade: gradeCode ? gradeCode : 'All',
          subject: activeBreadcrumb?.[0]?.title === "Math" ? SubjectCodes.MATH : SubjectCodes.ELA,
          page_number: 0,
          page_size: 10,
        },
        callback: callbackData => {
          setSearchResults(callbackData.searches);
          const props = {
            searchTerm: query,
            countOfSearchResults: callbackData.searches?.length,
            grade: onboardingGrade,
          };
          PrintableWorksheetsEvents.startedPrintablesSearch(props);
        },
        errorCallback: err => {
          // sendErrorToSentry(new Error("failed to getSearchResults on search worksheet screen"), { error: err })
        }
    });
  }

  const postUserSearches = ({ type = "", searchTerm = "", worksheetId = "" }) => {
    let params = {}
    if (type === "SEARCH") {
      params = {
        entity_type: "search",
        search_term: searchTerm,
        subject: subjectCode,
        grade: gradeCode,
      }
    }
    else {
      params = {
        entity_type: "worksheet_select",
        entity_id: worksheetId,
        subject: subjectCode,
        grade: gradeCode,
      }
    }
    PrintableWorksheetsApi.postUserSearches({
      userId: userId,
      params,
      callback: res => {
        setFilteredSearchTerm(res?.search_entity?.search_term);
      },
      errorCallback: err => {
        // sendErrorToSentry(new Error("failed to postUserSearches on search worksheet screen"), { error: err })
      }
    });
  }

  const getRecentUserSearches = (trendingWsList = []) => {
    PrintableWorksheetsApi.getRecentUserSearches({
      userId: userId,
      params: {
        subject: subjectCode,
        grade: gradeCode,
        page_number: 0,
				page_size: 10
      },
      callback: callbackData => {
        if (callbackData.length > 0) {
          getSearchWorksheetByIds(callbackData)
        }
        else {
          setSearchType(searchTypes.TRENDING)
          setSearchResults(trendingWsList)
          setInitialLoading(false)
        }
      },
      errorCallback: err => {
        // sendErrorToSentry(new Error("failed to getRecentUserSearches on search worksheet screen"), { error: err })
      }
    });
  }

  const getWorksheetIds = (result) => {
    let ids = []
    result.map((item) => {
      if (item?.search_entity?.entity_type === 'WORKSHEET_SELECT') {
        ids.push(item.search_entity.entity_id)
      }
    })
    return ids
  }

  const modifyRecentSearches = ({ data, worksheetList = [] }) => {
    let recentSearches = data.map((item) => {
      let modifiedSearch = {}
      if (item?.search_entity?.entity_type === 'WORKSHEET_SELECT') {
        modifiedSearch = worksheetList.find((worksheet) => worksheet.id === item.search_entity.entity_id)
      }
      else {
        modifiedSearch = {
          ...item.search_entity,
          title: item.search_entity.search_term,
        }
      }
      return modifiedSearch
    })
    return recentSearches
  }

  const getSearchWorksheetByIds = (data) => {
    let ids = getWorksheetIds(data)
    if (ids.length !== 0) {
      PrintableWorksheetsApi.getWorksheetsByIds({
        params: {
          ids: getWorksheetIds(data)
        },
        callback: callbackData => {
          setSearchResults(modifyRecentSearches({ data, worksheetList: callbackData.searches }))
          setInitialLoading(false)
        },
        errorCallback: err => {
          // sendErrorToSentry(new Error("failed to getSearchWorksheetByIds on search worksheet screen"), { error: err })
        }
      });
    }
    else {
      setSearchResults(modifyRecentSearches({ data, worksheetList: [] }))
      setInitialLoading(false)
    }
  }

  const getTrendingWorksheets = () => {
    PrintableWorksheetsApi.getTrendingWorksheets({
      params: {
        grade: gradeCode,
        subject: subjectCode,
      },
      callback: callbackData => {
        setTrendingWorksheet(callbackData.searches)
        checkForFirstTimeClick(callbackData.searches)
      },
      errorCallback: err => {
        // sendErrorToSentry(new Error("failed to getTrendingWorksheet on search worksheet screen"), { error: err })
      }
    });
  }

  const searchOnClickHandler = () => {
    toggleDefaultSearch(false)
    fireViewedWorksheetSearchDropdown()
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.value.length > 0) {
      fireViewedWorksheetSearchResultsPage()
      postUserSearches({ type: "SEARCH", searchTerm: e.target.value })
      toggleDefaultSearch(true)
      setWorksheetName(e.target.value)
      goToSearchWorksheetScreen(e.target.value)
    }
  }

  const individualSearchClickHandler = (item, index) => {
    fireInteractedWorksheetSearchDropdown(index)
    fireViewedWorksheetSearchResultsPage()
    toggleDefaultSearch(true)
    if (item.entity_type === "SEARCH") {
      setWorksheetName(item.title)
      goToSearchWorksheetScreen(item.title)
      postUserSearches({ type: "SEARCH", searchTerm: item.title })
    }
    else {
      postUserSearches({ type: "WORKSHEET_SELECT", worksheetId: item.id })
      worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? setSelectedPdf(item) : onSearchClick(item);
      // setSelectedPdf(item);
    }
  }

  const onSearchClick = (wsDetail) => {
    if(isDesktop) {
      setWorksheetDetail(wsDetail);
      setShowWorksheetPreview(true);
      window.parent.triggerIsFlutterHeaderClickDisabled && window.parent.triggerIsFlutterHeaderClickDisabled();
      
      if(!canDownloadWs()) {
        setShowUnlockButton(true);
      }
  
      /// if preview popup is opened then unset all overflow properties in parent. (Safari/Firefox browser issue fix)
      const worksheetsRightDiv = window.document.getElementById('ws-right-div');
      worksheetsRightDiv.style.overflowX = 'unset';
      worksheetsRightDiv.style.overflowY = 'unset';
    }
    else {
      window.open(item?.pdf_url);
      PrintableWorksheetsEvents.downloadedWorksheetB2c({
        worksheetName: wsDetail.title,
        worksheetCode: wsDetail.code
      });
    }
  }

  useEffect(() => {
    const worksheetsRightDiv = window.document.getElementById('ws-right-div');
    const wsPreview = window.document.getElementById('ws-preview-wrapper');
    /// if preview popup is opened then no overflow property should set. 
    if(selectedPdf){
      if(worksheetsRightDiv && !wsPreview){
        worksheetsRightDiv.style.overflowX = 'visible';
        worksheetsRightDiv.style.overflowY = 'visible';
      }
    }
     else {
      if(worksheetsRightDiv && !wsPreview){
        worksheetsRightDiv.style.overflowY = 'auto';
        worksheetsRightDiv.style.overflowX = 'hidden';
      }
    }
  }, [selectedPdf]);

  const goToSearchWorksheetScreen = (title) => {
    // dispatch({ type: ReducerConstants.SET_WORKSHEET_VALUE, payload: title });
    const params = {
      query: title,
      grade: gradeCode,
      subject: activeBreadcrumb?.[0]?.title === "Math" ? SubjectCodes.MATH : SubjectCodes.ELA,
      page_number: 0,
      page_size: 1000,
    }
    setSearchScreenData({params, title, from: 'SEARCH'});
    setActiveScreen(PRINTABLE_WORKSHEET_SCREENS.SEARCH)
  }

  const fireInteractedWorksheetSearchDropdown = (index) => {
    if(worksheetsEnvironment == WorksheetsEnvironment.TEACHER_DASHBOARD){
      let props = {
        clickedOn: `Search Result ${index+1}`,
      }
      PrintableWorksheetsEvents.interactedWorksheetSearchDropdown(props);
    }
    else {
      const props = {
        searchTerm: worksheetName,
        searchResultSelected: `Search Result ${index+1}`,
        grade: activeGrade,
      };
      PrintableWorksheetsEvents.selectedPrintablesSearch(props);
    }
  }

  const fireViewedWorksheetSearchDropdown = () => {
    PrintableWorksheetsEvents.viewedWorksheetSearchDropdown();
  }

  const fireViewedWorksheetSearchResultsPage = () => {
    PrintableWorksheetsEvents.viewedWorksheetSearchResultsPage();
  }

  const crossOnClickHandler = () => {
    closeViewForSearch();
    setWorksheetName("")
  }

  const closeViewForSearch = () => {
    toggleDefaultSearch(true);
    setSearchResults([]); 
    toggleSwitchToIcon(isMobile ? true : false) 
    $('.worksheet-mobile-options').show();
  }
  const showViewForSearch = () => {
    toggleDefaultSearch(false);
    toggleSwitchToIcon(false)
    $('.worksheet-mobile-options').hide();
  }

  return (
    <>
      {showWorksheetPreview &&
        <WSPreview worksheetDetails={worksheetDetail} setShowWorksheetPreview={setShowWorksheetPreview} showWorksheetPreview={showWorksheetPreview} showUnlockButton={showUnlockButton} />
      }
      <OutsideClickHandler outsideClickHandler={closeViewForSearch}>
        {switchToIcon && isMobile ? (
          ReactDOM.createPortal(
            <div 
              className="search-icon-container" 
              onClick={() => { 
                  showViewForSearch();
                  const elem = document.getElementById('ws-header');
                  elem.scrollIntoView();
                }
              }
            >
             <SearchIcon />
          </div>,
            document.getElementById("searchIconPortal")
          )
          
        ) : (
            <div data-test-id="worksheet-search-container" className={`search-container ${!defaultSearch ? "increase-width" : ""}`} id='printables-search-icon'>
              <DebounceInput id="input-search" type="text" className={(!defaultSearch ? "increase-width" : "")}
                placeholder={searchPlaceholder ? searchPlaceholder : 'Search ' + subjectCode + ' worksheets...'}
                onClick={searchOnClickHandler}
                autoComplete="off"
                onChange={(e) => onSearchInputChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
                value={worksheetName}
                debounceTimeout={400}
              />
              <label htmlFor="input-search" />
              <i className="ws-search-icon">
                <SearchIconSvg />
              </i>
              {!defaultSearch &&
                <i className="ws-cross-icon">
                  <CrossIconSvg
                    onClick={crossOnClickHandler}
                  />
                </i>
              }
            </div>
        )}
        {!defaultSearch && searchResults?.length > 0 && (worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD || !initialLoading) &&
          <div className="search-dropdown" ref={(ref) => {
            if(ref && worksheetsEnvironment == WorksheetsEnvironment.STUDENT_DASHBOARD) {
              const elementDetails = ref.getBoundingClientRect();
              ref.style.maxHeight = `calc(100vh - ${elementDetails.top - 72}px)`;
            }
          }}>
            {searchResults?.length > 0 ?
              <div className="search-results">
                <div className="search-result-type">
                  {searchType}
                </div>
                {searchResults.map((item, index) => (
                  <li key={item?.id} className="search-result" onClick={() => { individualSearchClickHandler(item, index) }}>
                    <Highlighter
                      className="title"
                      highlightClassName="highlight-class"
                      searchWords={[worksheetName]}
                      autoEscape={true}
                      textToHighlight={item?.title}
                    />
                    <div className="tree-name">
                      {item.entity_type !== 'SEARCH' &&
                        <span> in {item?.search_nodes_titles?.join('/ ')}</span>
                      }
                    </div>
                  </li>
                ))}
              </div> :
              worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD && isMobile ? null : (
                <div className="no-search-result">
                  <div className="heading">
                    No result found for this grade
                  </div>
                  <div className="body">
                    We couldn’t understand what you mean, try searching something else.
                  </div>
                </div>
              )
            }
          </div>
        }
        {initialLoading && !defaultSearch && <SearchDropdownFallback/>}
      </OutsideClickHandler>
      {
        selectedPdf && selectedPdf.pdf_url &&
        <PDFViewer
          title={selectedPdf?.title}
          subtitle={selectedPdf?.meta_description}
          file={selectedPdf?.pdf_url}
          onBack={() => setSelectedPdf(null)}
          onDownload={() => onDownload(selectedPdf)}
          showSave={false}
          isMobileView
        />
      }
      <InvisibleInput/>
    </>
  )
}